import React from 'react'

import { useActions, useMutations } from 'src/hooks'
import { getTotal } from 'src/helpers'
import Editor from 'src/editor/containers/Editor/Editor'

type Props = {
  cardId: string
}

const Card: React.FC<Props> = props => {
  const { cardId } = props

  const mutations = useMutations()
  const actions = useActions()

  const handleSaveAndSend = async () => {
    const {
      createOrder: { order },
    } = await mutations.createOrder({
      order: { lines: [{ card: cardId }] },
    })
    actions.openOrder(order.id)
  }

  return (
    <Editor
      cardId={cardId}
      onAfterSave={handleSaveAndSend}
      onClose={actions.openCatalog}
      saveButtonLabel="Save &amp; Proceed to Checkout"
      secondaryAction={{
        label: 'Save & Close Card Editor',
        onClick: actions.openCatalog,
      }}
      context={{
        headerText: 'Editing custom card',
        footerLabel: card => <>Total: {getTotal(card.cost)}</>,
      }}
    />
  )
}

export default Card
